
import React, { useState } from "react";
import { Checkbox, Typography, Alert } from "antd";

const { Title, Text, Link } = Typography;

const Commitments = ({agreed, setAgreed }) => {
  const [showError, setShowError] = useState(false);

  const handleAgreeChange = (e) => {
    setAgreed(e.target.checked);
    if (e.target.checked) setShowError(false);
  };


  return (
    <div className="title-box">
      <Title level={4} className="title p-3">
        Enrollment Commitments & Agreements
      </Title>
        <p className="justified">
          As a parent/guardian of the student being enrolled, I authorize the enrollment of the
          student into the Stusphere, which is a Franchise of Stusphere, and I authorize the 
          enrollment according to the policies and procedures ofthe Stusphere . Stusphere policies
          and procedures found here:{" "}
          <Link href="stusphere.org" target="_blank">
            Stusphere rule book
          </Link>
          .
        </p>
            <p className="justified">
              By clicking the "I Agree" button at the bottom of this page, I agree that my student
              will submit 100% of their own work, and I commit to Academic Integrity by registering
              my student at Stusphere. I understand that it is my responsibility to oversee their 
              progress to ensure continuous online learning in the
              course(s).
            </p>

            <p className="justified">
              I also understand that should my student finish the segment in an extremely
              accelerated pace, my student may be subject to additional accountability measures.
              Failure to comply with the Academic Integrity commitment will be grounds for removal
              from the FLVS program. Further, I agree to have my student comply with all of the
              policies and procedures listed in the{" "}
              <Link href="stusphere.org" target="_blank">
                Stusphere Student Progression Plan
              </Link>{" "}
              and{" "}
              <Link href="stusphere.org" target="_blank">
                Stusphere Code of Conduct/Student Handbook
              </Link>
              , which is posted on my Student dashboard and at{" "}
              <Link href="stuspher.org" target="_blank">
                stusphere.org
              </Link>
              .
            </p>

            <p className="justified">
              Equipment: Your student needs his/her own working computer. A
              camera and speaker are optimum and a printer is preferable. Chromebooks are not able
              to access all of the curriculum provided.
            </p>
            <p className="justified">
              I hereby assign to Stusphere all right, title and interest in and to all the material I
              submit to Stusphere in conjunction with any course(s) I take with Stusphere. All personally
              identifying information provided to Stusphere will be maintained in compliance with the
              Family Educational Rights and Privacy Act of 1974 (FERPA) and other applicable
              privacy laws.
            </p>

            <p className="justified">
              Commercial Use of Academic Material: Selling course material to
              another person, student, entity, and/or uploading to a third-party vendor without the
              express written permission of Stusphere is prohibited. Course materials include, but are
              not limited to, class notes, instructor's power points, course syllabi, tests,
              quizzes, labs, instruction sheets, homework, study guides, and handouts.
            </p>

      <div style={{ marginTop: 24 }}>
        <Checkbox checked={agreed} onChange={handleAgreeChange}>
          <Text strong>
            I Agree{" "}
            <Text type="danger" style={{ fontWeight: 400 }}>
              (required)
            </Text>
          </Text>
        </Checkbox>
      </div>

      {showError && (
        <Alert
          type="error"
          message='Please check "I Agree" to proceed.'
          showIcon
          style={{ marginTop: 12 }}
        />
      )}
    </div>
  );
};

export default Commitments;